import { render, staticRenderFns } from "./deletePhoto.vue?vue&type=template&id=ddfe47d4"
import script from "./deletePhoto.vue?vue&type=script&lang=js"
export * from "./deletePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports